export const PET_SESSION_KEY = 'sanitas-pet'

export const PET_TYPE = {
  CAT: 'CAT',
  DOG: 'DOG',
}

export const GENDER = {
  FEMALE: 'FEMALE',
  MALE: 'MALE',
}

export const PET_BREED_TYPES = {
  PEDIGREE: 'PEDIGREE',
  CROSSBREED: 'CROSSBREED',
  MIXED: 'MIXED',
}

export const MAIN_QUESTIONS_KEYS = {
  HAS_MEDICAL_CONCERNS: 'hasMedicalConcerns',
  REQUIRES_ONGOING_CARE: 'requiresOngoingCare',
}

export const EXTENDED_HEALTH_QUESTIONS_KEYS = [
  'hasHeartCondition',
  'hasKidneyOrUrinaryCondition',
  'hasHormonalOrEndocrineDisorder',
  'hasAllergiesOrAsthma',
  'hasCancer',
  'hasJointOrSpinalCondition',
  'hasEpilepsy',
]

export const TARIFF_VARIANTS = {
  SMART: 'SMART',
  PREMIUM: 'PREMIUM',
}

export const DEDUCTIBLE_OPTIONS = {
  CHF_0: { key: 'CHF_0', value: 0 },
  CHF_250: { key: 'CHF_250', value: 250 },
  CHF_500: { key: 'CHF_500', value: 500 },
  CHF_1000: { key: 'CHF_1000', value: 1000 },
  CHF_2000: { key: 'CHF_2000', value: 2000 },
}

export const PET_REJECTION_ERROR = {
  PET_BAD_HEALTH_CONDITION: 'PET_BAD_HEALTH_CONDITION',
  PET_MUST_BE_AT_LEAST_8_WEEKS_OLD: 'PET_MUST_BE_AT_LEAST_8_WEEKS_OLD',
}

export const IGNORED_PET_ERROR_CODES = new Set(Object.values(PET_REJECTION_ERROR))

export const TARIFF_VARIANTS_AMOUNTS = {
  SMART: 10000,
  PREMIUM: 20000,
}

export const LOCALE_MAP = {
  de: 'de-CH',
  en: 'en-US',
  fr: 'fr-CH',
  it: 'it-CH',
}
